module.exports = __webpack_public_path__ + "img/invitation-expired.2c69060a.png";